import * as React from 'react';

import { socialSignInStart } from '@webapp/sdk/auth';
import { setLocalStorageItem } from '@webapp/utils/localstorage';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import SignupSocial from '@components/actions/signup-social';

export interface SocialAuthCtrlProps {
  label: React.ReactNode;
}

export const SocialAuthCtrl: React.FC<SocialAuthCtrlProps> = (props) => {
  const signIn = (provider: 'Facebook' | 'Google') => {
    setLocalStorageItem('provider', provider);
    socialSignInStart(provider);
  };
  return (
    <Wrapper justifyContent="space-between" alignItems="center">
      <SignupSocial
        className="item"
        company="facebook"
        onClick={() => signIn('Facebook')}
      >
        {props.label}
        <br />
        Facebook
      </SignupSocial>
      <SignupSocial
        className="item"
        company="google"
        onClick={() => signIn('Google')}
      >
        {props.label}
        <br />
        Google
      </SignupSocial>
    </Wrapper>
  );
};

export default SocialAuthCtrl;

const Wrapper = styled(Flex)`
  flex-direction: column;
  gap: 5px;

  ${({ theme }) => `@media screen and ${theme.device.mobileL}`} {
    flex-direction: row;
  }
`;
